import { environment } from "models/Environment";

export class AppRoutes {
  static Home = "/";

  static Voting = "/voting";

  static VotingOpen = "/voting/open";

  static VotingDone = "/voting/done";

  static VotingDetail = "/voting/:boardId/:runId";

  static VoteRedirect = "/vote/:runId";

  static RunRedirect = "/run/edit/:runId";

  static Boards = "/boards";

  static BoardsAll = "/boards/all";

  static BoardsMy = "/boards/my";

  static Board = "/boards/:boardId";

  static BoardSettings = "/boards/:boardId/settings";

  static Run = "/boards/:boardId/runs/:runId";

  static NotFound = "/*";

  static toBoard(boardId: string | undefined) {
    let url = AppRoutes.Board;
    url = replaceBoardId(url, boardId);
    checkPlaceholders(url);
    return url;
  }

  static toRun(boardId: string | undefined, runId: string | undefined) {
    let url = AppRoutes.Run;
    url = replaceBoardId(url, boardId);
    url = replaceRunId(url, runId);
    checkPlaceholders(url);
    return url;
  }

  static toVoting(boardId: string | undefined, runId: string | undefined) {
    let url = AppRoutes.VotingDetail;
    url = replaceBoardId(url, boardId);
    url = replaceRunId(url, runId);
    checkPlaceholders(url);
    return url;
  }

  static toBoardSettings(boardId: string) {
    let url = AppRoutes.BoardSettings;
    url = replaceBoardId(url, boardId);
    checkPlaceholders(url);
    return url;
  }

  static toAuditLog(entityName: string, entityId: string) {
    return getBackendUrl(`/auditLog/${entityName}/${entityId}`);
  }

  static toAdmin() {
    return getBackendUrl(`/admin`);
  }

  static toUser(userId: string | undefined) {
    return getBackendUrl(`/users/${userId}`);
  }

  static toAbout(): string | undefined {
    return getBackendUrl(`/about`);
  }
}

function replaceRunId(url: string, runId: string | undefined): string {
  if (!runId) throw new Error('Argument "runId" is mandatory!');
  return url.replace(":runId", runId);
}

function replaceBoardId(url: string, boardId: string | undefined): string {
  if (!boardId) throw new Error('Argument "boardId" is mandatory!');
  return url.replace(":boardId", boardId);
}

function checkPlaceholders(url: string) {
  if (url.includes(":")) {
    throw new Error(`Url still contains ':' placeholders: ${url}`);
  }
}

function getBackendUrl(path: string) {
  return `${environment.backendUrl}${path}`;
}
